import PropTypes from 'prop-types';
import BaseSelectorReadonlyToInput from "../Select/BaseSelectorReadonlyToInput";
import AssetService from "../../services/AssetService";

const processData = (data) => {
  let newData = []

  data.forEach(item => {
    const {epc, ...itemWithoutEpc} = item
    
    item.tags && item.tags.forEach(tag => {
      newData.push({ epc: tag, ...itemWithoutEpc })
    })
  });

  return newData.length > 0 ? newData : data
}

class AssetSelector extends BaseSelectorReadonlyToInput {

  constructor(props) {
    super(props);
    this.state = {
      ...this.state,
      filterParamName : 'tags.value',
      defaultValue: props.defaultValue && props.defaultValue.map(x => ({'epc.value': x.epc.value, ...x})),
      title: props.title || 'Produto/Ativo',
      label: 'epc.value',
      url: AssetService.ALL_URL,
      placeholder: props.placeholder,
      style: props.style,
      processData
    };
  }
}

AssetSelector.propTypes = {
  required: PropTypes.bool,
  setValue: PropTypes.func,
  defaultValue: PropTypes.string,
  readonly: PropTypes.bool,
  onChange: PropTypes.func,
  multiple: PropTypes.bool,
  placeholder: PropTypes.string
};

export default AssetSelector;



// WEBPACK FOOTER //
// ./src/component/Asset/AssetSelector.js